export default {
  添加群组: 'Add Group',
  编辑群组: 'Edit Group',
  删除群组: 'Delete Groups',
  我的客户库: 'My Client Base',
  客户库: 'Client Base',
  客户库群组: 'Client Base group',
  传真: 'Fax',
  座机号: 'Landline number',
  所属群组: 'Group',
  正在提交数据提示: 'Submitting',
  个客户: 'customers',
  已选择: 'Selected',
  通讯录群组提示4: 'Group description is limited to 120 characters！',
  通讯录群组提示3: 'Group description cannot be empty!',
  通讯录群组提示2: 'Group name is limited to 10 characters！',
  通讯录群组提示1: 'Group name cannot be empty!',
  修改成功: 'Successfully Modified',
  角色类型选填: 'Role type (optional)',
  通讯录自主添加提示13: 'Enterprise name is limited to 120 characters！',
  通讯录自主添加提示12: 'The position is limited to 30 characters！',
  通讯录自主添加提示11: 'Email Format Error!',
  通讯录自主添加提示10: 'Email is limited to 60 characters！',
  通讯录自主添加提示9: 'Phone number cannot be empty!',
  通讯录自主添加提示8: 'WeChat is limited to 30 characters！',
  微信号: 'Wechat',
  通讯录自主添加提示7: 'The fixed phone number is limited to 30 characters!',
  通讯录自主添加提示6: 'Fixed Phone Format Error!',
  通讯录自主添加提示5: 'Phone Number Format Error!',
  通讯录自主添加提示4: 'Mobile phone number is limited to 15 characters!',
  通讯录自主添加提示3: 'Phone number cannot be empty!',
  通讯录自主添加提示2: 'Customer name is limited to 30 characters！',
  通讯录自主添加提示1: 'Customer name cannot be empty!',
  通讯录大数据库: 'Big database of address book',
  通讯录客户自增: 'Customer self-increasing',
  通讯录客户名片: 'Address Book',
  拍照识别: 'Photo Recognition',
  添加客户: 'Add Customer',
  删除成功: 'Successfully Delete',
  群组客户人数: 'Number of group customers',
  群组描述: 'Group description',
  群组名称: 'Group name',
  群组ID: 'Group ID',
  是否付费客户: 'Whether paying customers',
  确定要删除吗: 'Are you sure you want to delete it?',
  从云数据新增: 'Add from cloud data',
  自主新增客户: 'Independently added customers',
  请输入: 'please enter',
  角色类型: 'Role type',
  客户类型: 'Role type',
  新增群组: 'Add group',
  通讯录提示1: 'Let’s try big data customers now!',
  客户管理: 'Customer management',
  群组管理: 'Group management',
}
